import React, { useState, useEffect } from "react";
import { Select, Input, Button, Modal, Form, Spin, Icon } from "antd";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { advget, advpost } from "$ACTIONS/TlcRequest";
import { getE2BBValue } from "$ACTIONS/helper";
import showMessage from "$ACTIONS/messageUtil";
import showPromotionErrorModal from "@/Promotion/UI";
import { showResultPopup } from "$ACTIONS/helper";
import CustomCheckbox from "@/CustomCheckbox";
import { numberformatter } from "$ACTIONS/util";

const { Option } = Select;

// 衝突確認彈窗
const ConflictModal = ({ visible, onClose, conflictData, onSuccess }) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleCheckSignupBonus = async () => {
        try {
            setIsLoading(true);
            const res = await advget(
                `${ApiPort.GETIsSignupBonus}&productGroup=${conflictData?.productGroup}`
            );

            Pushgtagdata(
                "Bonus",
                "Confirm Bonus Type and Cancel Ongoing",
                "Promotion_C_ConfirmType_CancelOngoing"
            );

            if (res?.isSuccess && res?.result === true) {
                showResultPopup({
                    type: "confirm",
                    title: "ยืนยันการยกเลิกโปรโมชั่น",
                    content:
                        "โปรโมชั่นนี้สามารถขอรับได้เพียงครั้งเดียวเท่านั้น\nหากยกเลิกจะไม่สามารถขอรับใหม่ได้",
                    okText: "ฝากตอนนี้",
                    cancelText: "ปิด",
                    onOk: () => {
                        handleConfirmSubmit(true);
                    },
                    onCancel: () => {},
                });
            } else if (res?.isSuccess && res?.result === false) {
                // 如果不需要显示 Reminder，直接提交 API
                handleConfirmSubmit(false);
            } else {
                showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
            }
        } catch (error) {
            console.error("Error checking signup bonus status:", error);
            showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
        } finally {
            setIsLoading(false);
        }
    };

    const handleConfirmSubmit = async (isTriggerBySignUpOkBtn) => {
        try {
            setIsSubmitting(true);

            const requestBody = {
                participantId: conflictData?.participantId,
                productGroup: conflictData?.productGroup,
                blackboxValue: getE2BBValue(),
                isCancel: true,
            };

            const res = await advpost(
                ApiPort.POSTCampaignApplications,
                requestBody
            );

            const { isSuccess, result } = res || {};
            const { errorCode, message: apiMessage, data: unfinishInfo } = result || {};

            if (isTriggerBySignUpOkBtn) {
                Pushgtagdata(
                    "Bonus", 
                    "Confirm Cancel Sign Up Bonus", 
                    "Bonus_C_ConfirmCancelSignUpBonus",
                    false,
                    isSuccess ? [] : [
                        {
                            customVariableKey: "Bonus_C_ConfirmCancelSignUpBonus_ErrorMsg",
                            customVariableValue: apiMessage,
                        },
                    ]
                );
            }

            if (isSuccess) {
                showMessage("success", "โปรโมชั่นเริ่มแล้ว", 80); //优惠已开始
                onSuccess();
            } else {
                if (errorCode === "CP30013" && unfinishInfo) {
                    // 尚有投注未结算，请稍候再尝试
                    const { productVendors, productGroupName } = unfinishInfo || {};
                    const productText = productVendors?.length > 1 ? productGroupName : productVendors?.[0];
                    showPromotionErrorModal(errorCode, apiMessage, productText);
                } else {
                    showPromotionErrorModal(errorCode, apiMessage);
                }
            }
        } catch (error) {
            console.error("Error during conflict submission:", error);
            showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            className="custom-modal-white-bg conflict-modal"
            visible={visible}
            onCancel={onClose}
            footer={null}
            centered
            title="เคล็ดลับสำคัญ"
            width={426}
        >
            <Spin spinning={isLoading || isSubmitting} tip="กำลังโหลด กรุณารอสักครู่...">
                <div className="conflict-modal-content">
                    {/* Warning Icon */}
                    <div className="warning-icon">
                        <img
                            src="/th/img/icon/warning.svg"
                            alt="Warning"
                        />
                    </div>

                    {/* Main Message */}
                    <p className="main-message">
                        {conflictData?.pullbackAmount > 0
                            ? <>ขณะนี้คุณมีโปรโมชันที่กำลังดำเนินอยู่<br />โปรโมชั่นที่มีอยู่จะถูกยกเลิกและ <strong>{numberformatter(conflictData?.pullbackAmount, 2, "removeWhenDecimalAllZero")}</strong> บาท จะถูกดึงกลับ</>
                            : <>ขณะนี้คุณมีโปรโมชันที่กำลังดำเนินอยู่<br />โปรโมชั่นที่มีอยู่จะถูกยกเลิก</>}
                    </p>

                    {/* Bonus Information */}
                    <div className="bonus-info">
                        <p>
                            จำนวนโบนัสจาก
                            <br />
                            โปรโมชั่นที่กำลังดำเนินการ
                            <span> ฿ {numberformatter(conflictData?.bonusGiven || 0, 2, "removeWhenDecimalAllZero")}</span>
                        </p>
                        <p>
                            จำนวนโบนัส โปรโมชั่นใหม่
                            <span> ฿ {numberformatter(conflictData?.givenAmount || 0, 2, "removeWhenDecimalAllZero")}</span>
                        </p>
                    </div>

                    {/* Additional Information */}
                    <p className="additional-info">
                        ยอดหมุนเวียนสะสมในช่วงโปรโมชั่นจะถือว่าเป็นโมฆะ
                    </p>

                    {/* Checkbox */}
                    <div className="checkbox-container">
                        {/* 我已阅读上述说明，并同意取消进行中的优惠 */}
                        <CustomCheckbox
                            checked={isChecked}
                            onChange={(v) => setIsChecked(v)}
                            label={
                                <>
                                    ฉันได้อ่านเนื้อหาข้างต้นแล้ว
                                    <br />
                                    และ<strong>ยินยอมที่จะยกเลิกข้อเสนอ</strong>
                                    ที่กำลังดำเนินอยู่
                                </>
                            }
                        />
                    </div>

                    {/* Action Buttons */}
                    <div className="action-buttons">
                        <Button
                            type="primary"
                            size="large"
                            block
                            disabled={!isChecked}
                            onClick={handleCheckSignupBonus}
                        >
                            ยืนยัน
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            block
                            ghost
                            onClick={onClose}
                        >
                            กลับ
                        </Button>
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};

/**
 * onSuccess 的行為依據觸發來源不同：
 * - 從 TnC 開啟的 StartPromotionModal，onSuccess 會關閉 TnC 彈窗。
 * - 從 NotStarted Tab 開啟的 StartPromotionModal，onSuccess 會執行 goToInProgress，跳轉到進行中的優惠頁面。
 */

const StartPromotionModal = ({ visible, onClose, selectedItem, onSuccess }) => {
    const [isSingleCategory, setIsSingleCategory] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [inputTurnover, setInputTurnover] = useState(0);
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [open, setOpen] = useState(false);
    const [conflictModalVisible, setConflictModalVisible] = useState(false);
    const [conflictData, setConflictData] = useState(null);

    const productGroups = selectedItem?.productGroups || [];
    const givenAmount = selectedItem?.givenAmount || 0;
    const participantId = selectedItem?.participantId;

    useEffect(() => {
        if (productGroups.length === 1) {
            setIsSingleCategory(true);
            setSelectedCategory(productGroups[0]?.productGroup || null);
            setInputTurnover(productGroups[0]?.turnoverAmount || 0);
            setErrorMessage(""); // 清除錯誤訊息
        } else {
            setIsSingleCategory(false);
            setSelectedCategory(undefined);
            setInputTurnover(0);
        }
    }, [productGroups]);

    const handleSelectChange = (value) => {
        setSelectedCategory(value);
        const selectedGroup = productGroups.find(
            (group) => group.productGroup === value
        );
        setInputTurnover(selectedGroup?.turnoverAmount || 0);
        setErrorMessage(""); // 清除錯誤訊息
    };

    const handleConfirm = async () => {
        if ((!selectedCategory && !isSingleCategory) || errorMessage) {
            return;
        }

        Pushgtagdata(
            "Bonus",
            "Confirm Rebate Game Type",
            "Bonus_C_ConfirmRebateGameType"
        );

        try {
            setIsSubmitting(true); // 開始提交

            const requestBody = {
                participantId,
                productGroup: selectedCategory,
                blackboxValue: getE2BBValue(),
                isCancel: false,
            };

            const res = await advpost(
                ApiPort.POSTCampaignApplications,
                requestBody
            );
            if (res?.isSuccess) {
                showMessage("success", "โปรโมชั่นเริ่มแล้ว", 80); // 优惠已开始
                onClose();
                onSuccess();
            } else {
                const errorCode = res?.result?.errorCode;
                const apiMessage = res?.result?.message;

                switch (errorCode) {
                    case "CP30011":
                        setConflictData({
                            pullbackAmount: res?.result?.data?.pullbackAmount,
                            bonusGiven: res?.result?.data?.bonusGiven,
                            givenAmount,
                            participantId,
                            productGroup: selectedCategory,
                        });
                        setConflictModalVisible(true);
                        break;
                    case "CP30018":
                        //正在進行的促銷活動等待確認；請聯絡客戶服務尋求協助。
                        setErrorMessage(
                            "โปรโมชั่นที่กำลังดำเนินการอยู่ รอการยืนยัน ;\nโปรดติดต่อฝ่ายบริการลูกค้าเพื่อขอความช่วยเหลือ"
                        );
                        break;
                    case "CP30020":
                        //成交尚未完成。請等到活動完成後再開始促銷。
                        setErrorMessage(
                            "การทำยอดหมุนเวียนยังไม่เสร็จสมบูรณ์\nกรุณารอจนกว่าจะครบแล้วจึงเริ่มโปรโมชั่น"
                        );
                        break;
                    case "CP30003":
                    case "CP30014":
                    case "CP30015":
                    default:
                        // 通用錯誤處理
                        showPromotionErrorModal(errorCode, apiMessage);
                        break;
                }
            }
        } catch (error) {
            console.error("Error during submission:", error);
            showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Modal
                className="custom-modal-white-bg start-promotion-modal"
                visible={visible}
                onCancel={onClose}
                footer={null}
                centered
                title="รายละเอียด โปรโมชั่น" //优惠活动详情
                width={426}
            >
                <Spin spinning={isSubmitting} tip="กำลังโหลด กรุณารอสักครู่...">
                    <Form layout="vertical" className="modal-content">
                        <div className="title">
                            {/* 以该游戏类别进行有效流水累计 / 选择游戏类别进行有效流水累计 */}
                            {isSingleCategory
                                ? "ยอดหมุนเวียนสะสมที่ถูกต้องแสดงตามหมวดหมู่เกม"
                                : "เลือกหมวดหมู่เกม เพื่อสะสมยอดหมุนเวียนที่ถูกต้อง"}
                        </div>

                        {/* 游戏类别 */}
                        <Form.Item label="หมวดหมู่เกม">
                            {isSingleCategory ? (
                                <Input
                                    value={productGroups[0]?.name || ""}
                                    readOnly={true}
                                    disabled={true}
                                    size="large"
                                />
                            ) : (
                                <Select
                                    className="custom-select"
                                    dropdownClassName="custom-dropdown"
                                    placeholder="เลือกหมวดหมู่เกม"
                                    value={selectedCategory}
                                    onChange={handleSelectChange}
                                    onDropdownVisibleChange={(visible) =>
                                        setOpen(visible)
                                    }
                                    size="large"
                                    suffixIcon={
                                        <img
                                            src="/th/img/icon/gray-arrow.svg"
                                            className={`dropdown-arrow ${
                                                open ? " open" : ""
                                            }`}
                                        />
                                    }
                                    getPopupContainer={(triggerNode) =>
                                        triggerNode.parentNode
                                    }
                                >
                                    {productGroups.map((group) => (
                                        <Option
                                            key={group.productGroup}
                                            value={group.productGroup}
                                        >
                                            <span>{group.name}</span>
                                            {selectedCategory ===
                                                group.productGroup && (
                                                <img
                                                    alt="check"
                                                    src="/th/img/icon/miniTick.svg"
                                                    className="custom-check-icon"
                                                />
                                            )}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                            {errorMessage && (
                                <div className="error-message">
                                    {errorMessage}
                                </div>
                            )}
                        </Form.Item>
                        {/* 可得彩金 */}
                        <Form.Item label="โบนัสที่มีอยู่">
                            <Input
                                value={
                                    isSingleCategory || selectedCategory
                                        ? numberformatter(givenAmount, 2, "removeWhenDecimalAllZero")
                                        : 0
                                }
                                readOnly={true}
                                disabled={true}
                                size="large"
                            />
                        </Form.Item>
                        {/* 所需流水 */}
                        <Form.Item label="ยอดหมุนเวียนที่ต้องการ">
                            <Input
                                value={
                                    isSingleCategory || selectedCategory
                                        ? numberformatter(inputTurnover, 2, "removeWhenDecimalAllZero")
                                        : 0
                                }
                                readOnly={true}
                                disabled={true}
                                size="large"
                            />
                        </Form.Item>

                        {/* 确认 / 返回 */}
                        <div className="action-buttons">
                            <Button
                                className="btn-confirm"
                                type="primary"
                                size="large"
                                block
                                disabled={
                                    (!isSingleCategory && !selectedCategory) ||
                                    errorMessage
                                }
                                onClick={handleConfirm}
                            >
                                ยืนยัน
                            </Button>
                            <Button
                                className="btn-back"
                                type="primary"
                                size="large"
                                block
                                ghost
                                onClick={onClose}
                            >
                                กลับ
                            </Button>
                        </div>
                    </Form>
                </Spin>
            </Modal>
            <ConflictModal
                visible={conflictModalVisible}
                onClose={() => setConflictModalVisible(false)}
                conflictData={conflictData}
                onSuccess={() => {
                    onClose();
                    onSuccess();
                }}
            />
        </>
    );
};

export default StartPromotionModal;
